import {
    FETCH_WORKLIST_START,
    FETCH_WORKLIST_SUCCESS,
    FETCH_WORKLIST_ERROR,
    SET_WORKLIST_FILTER,
    REMOVE_LOCKED_VISIT,
    SET_WORKLIST_PAGINATION,
    VIEW_WORKLIST_VISIT_LOADING_START,
    VIEW_WORKLIST_VISIT_LOADING_END,
    RESET_WORKLIST_FILTER

} from '../../actions/mrt/worklistAction';
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    worklist: [],
    searchFilter: {
        searchText: "",
        mipIds: [],
        modalityIds: [],
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "asc" }],
    skippedVisits: [],
    autoNextVisit: false,

};

const worklistReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_WORKLIST_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_WORKLIST_SUCCESS: {

            return { ...state, error: '', message: '', loading: false, worklist: action.worklist };
        }
        case FETCH_WORKLIST_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }

        case SET_WORKLIST_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }
        case REMOVE_LOCKED_VISIT: {
            // const { visit } = action.report;
            newState = { ...state };
            let newWorklist = [...newState.worklist];
            // index = newWorklist.findIndex(report=> report.visit.reportId === visit.reportId);
            index = newWorklist.findIndex(report => report.reportId === action.report.reportId);
            if (index > -1) {
                newWorklist.splice(index, 1);
                newState.worklist = [...newWorklist];
            }
            return newState;
        }
        case SET_WORKLIST_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case VIEW_WORKLIST_VISIT_LOADING_START: {
            return { ...state, loading: true };
        }
        case VIEW_WORKLIST_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }
        case RESET_WORKLIST_FILTER: {
            newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }

        default:
            return state;
    }
}

export default worklistReducer;
